import { createGlobalState } from 'react-use';

type GlobalSuccessProp = string | Array<{ key: string; message: string }> | undefined;
export const useGlobalSuccess = createGlobalState<GlobalSuccessProp>(undefined);

export type SetGlobalSuccess = (messages: GlobalSuccessProp) => void;
